import Button from '@atoms/Button/Button';
import ColourSwatchVariantEnum from '@models/enums/ColourSwatchVariantEnum';
import SiteEnum from '@models/enums/SiteEnum';
import {
  ColourSwatchCardBG,
  IColourSwatchCard,
} from '@models/IColourSwatchCard';
import { ILink } from '@models/ILink';
import ColourSwatchCard from '@molecules/ColourSwatchCard/ColourSwatchCard';
import ColourSwatchGallery from '@molecules/ColourSwatchGallery/ColourSwatchGallery';
import DrawerWrapper from '@molecules/DrawerWrapper/DrawerWrapper';
import { useRef, useState } from 'react';

export interface IColourSwatchCardWithDrawerProps extends IColourSwatchCard {
  collectionLink?: ILink;
  downloadLink?: ILink;
  site?: SiteEnum;
}

const ColourSwatchCardWithDrawer = (
  props: IColourSwatchCardWithDrawerProps
) => {
  const {
    colourName,
    colourCode,
    description,
    downloadLink,
    images,
    collectionLink,
    site,
  } = props;

  const swatchCardRef = useRef<HTMLDivElement>(null);
  const [drawerOpen, setDrawerOpen] = useState(false);
  const [isHovered, setIsHovered] = useState(false);
  return (
    <>
      <ColourSwatchCard
        {...props}
        variant={ColourSwatchVariantEnum.Detailed}
        site={SiteEnum.B2B}
        onClick={(e) => {
          const target = e?.target as HTMLElement | null;
          const wasCarouselButtonClicked = target?.tagName === 'BUTTON';

          // Stops the drawer from opening if the carousel navigation arrow was clicked
          if (!!images?.length && wasCarouselButtonClicked) {
            return;
          }

          setDrawerOpen(true);
        }}
        bgColour={ColourSwatchCardBG.Grey}
        triggerRef={swatchCardRef}
      />
      <DrawerWrapper
        preTitle={colourCode}
        title={colourName}
        description={description}
        setIsOpen={setDrawerOpen}
        isOpen={drawerOpen}
        wrapperStyles="tw-h-full tw-flex tw-flex-col"
        visibleOverflow
        restoreFocusRef={swatchCardRef}
        site={site}
      >
        <div className="tw-flex tw-flex-col tw-gap-6 tw-px-4 tw-pb-20 tw-pt-6 md:tw-gap-10 md:tw-px-12 md:tw-py-10">
          <div
            onMouseEnter={() => setIsHovered(true)}
            onMouseLeave={() => setIsHovered(false)}
            onFocus={() => setIsHovered(true)}
            onBlur={() => setIsHovered(false)}
          >
            <ColourSwatchGallery
              {...props}
              inView={true}
              isHovered={isHovered}
              tag={undefined}
            />
          </div>
          {(downloadLink?.url || collectionLink?.url) && (
            <div className="tw-flex tw-w-full tw-flex-col tw-gap-3 md:tw-flex-row ">
              {downloadLink?.url && (
                <Button
                  variant="yellow"
                  modifier="outline"
                  label={downloadLink.text}
                  href={downloadLink.text}
                  target={downloadLink.target}
                  buttonClasses="tw-w-full tw-whitespace-nowrap"
                  as="link"
                />
              )}
              {collectionLink?.url && (
                <Button
                  variant="yellow"
                  label={collectionLink.text}
                  href={collectionLink.url}
                  target={collectionLink.target}
                  buttonClasses="tw-w-full tw-whitespace-nowrap"
                  as="link"
                />
              )}
            </div>
          )}
        </div>
      </DrawerWrapper>
    </>
  );
};
export default ColourSwatchCardWithDrawer;
